import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { OwnersDisplayGridRowDataFragmentGql } from './OwnersDisplayGridRowFragmentGql';

// Should fetch same nodes as TableDownstreamOwnerIdsFilteredByColumnQuery
export const TableDownstreamOwnersFilteredByColumnQueryGql: DocumentNode = gql`
query TableDownstreamOwnersFilteredByColumnQuery($columnId: ID!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  columns(filter: {id: $columnId}) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowDataFragment
      }
    }
  }
}
${OwnersDisplayGridRowDataFragmentGql}
`;
